import React from 'react';

const Nav = () => {
  return (
    <>
      <div className="w3-top nav__all">
        <div className="w3-bar w3-left-align w3-large">
          <a
            href="#home"
            rel="noreferrer"
            className="w3-bar-item  w3-padding-large bg-item-nav"
          >
            <i className="fa fa-home w3-margin-right"> I-CREATE</i>
          </a>
          <a
            href="#skills"
            rel="noreferrer"
            className="w3-bar-item btn-code w3-hide-small w3-padding-large"
            title="scroll"
          >
            <i className="fa fa-code"></i>
          </a>
        </div>
      </div>
    </>
  );
};

export default Nav;
